module.exports = __webpack_public_path__ + "img/beer_id-90.ec89d0fd.png";